// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".component[data-v-523b8fd0]{background-color:#fff}.img-fluid[data-v-523b8fd0]{border-left:2px solid var(--primary-color);min-width:100%;width:100%}.banner-image[data-v-523b8fd0]{background:#fff;min-height:150px}@media screen and (max-width:767px){.img-fluid[data-v-523b8fd0]{border-bottom:2px solid var(--primary-color)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
